import axios from "axios";
import { priceCheckURL } from "utils/constants";

function latestAsync(fn) {
    let lastCall = {};

    return (...args) => {
        let variantId = args[0].variant;

        if(!lastCall[variantId]) {
            lastCall[variantId] = 0;
        }


        const callId = ++lastCall[variantId];

        return new Promise((resolve, reject) => {
            fn(...args)
                .then((result) => {
                    if (callId === lastCall[variantId]) {
                        resolve(result);
                    } else {
                        reject('');
                    }
                })
                .catch((error) => {
                    if (callId === lastCall[variantId]) {
                        reject(error);
                    }
                });
        });
    };
}

// Cache resolved responses and share in-flight requests keyed by query string.
// Price for a given query is deterministic, so repeating an identical request
// would otherwise trigger a 304 revalidation (which axios treats as an error
// and we'd lose the price data). This also dedupes rapid user-driven spam.
const responseCache = new Map();
const inFlightRequests = new Map();

const fetchCalculator = async (items) => {
    const query = Object.entries(items).map((item) => item.join("=")).join("&");

    if (responseCache.has(query)) {
        return responseCache.get(query);
    }

    if (inFlightRequests.has(query)) {
        return inFlightRequests.get(query);
    }

    const request = axios.get(`${priceCheckURL}?${query}`)
        .then((response) => {
            responseCache.set(query, response);
            inFlightRequests.delete(query);
            return response;
        })
        .catch((error) => {
            inFlightRequests.delete(query);
            // eslint-disable-next-line no-console
            console.log(error);
            return { data: { error: "Missing parameters" } };
        });

    inFlightRequests.set(query, request);
    return request;
};

const calculatePrice = latestAsync(async (items) => {
    const calculatedResponse = await fetchCalculator(items);
    return calculatedResponse?.data;
});

export default calculatePrice;
